export enum PageType {
  BLOG = 'blog',
  COMMUNITY_PAGE = 'community_page',
  IDEAENGINE_CATEGORY = 'ideaEngine_category',
  PEOPLE = 'people',
  PAGE = 'page',
  URL = 'url',
  SURVEY = 'survey'
}
